import qs from 'qs';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: OrderState = {
  all: [],
  viewing: undefined,
};

const getters: GetterTree<OrderState, RootState> = {
  all(state: OrderState): Order[] {
    return state.all;
  },
  viewing(state: OrderState): Order | undefined {
    return state.viewing;
  },
};

const mutations: MutationTree<OrderState> = {
  RESET(state: OrderState) {
    state.all = [];
    state.viewing = undefined;
  },
  UPDATE_MODEL(state: OrderState, payload: Order) {
    const index = state.all.findIndex((model: Order) => model.id === payload.id);

    if (index === -1) {
      state.all.push(payload);
    } else {
      state.all[index] = payload;
    }
  },
  SET_MODELS(state: OrderState, payload: Order[]) {
    state.all = payload;
  },
  SET_VIEWING(state: OrderState, payload: Order) {
    state.viewing = payload;
  },
  ADD_MODELS(state: OrderState, payload: Order[]) {
    state.all = [...state.all, ...payload];
  },
};

const resource: string = 'orders';

const actions: ActionTree<OrderState, RootState> = {
  index({ commit, rootState }, payload: { query: IndexQuery<Order>; workspaceId: number }) {
    const queryString = qs.stringify(payload?.query, { encode: false });
    return rootState.api
      .get(`${resource}?${queryString}`, { withCredentials: true, headers: { common: { 'x-workspace-id': payload.workspaceId } } })
      .then((response: { data: Order }) => {
        if (payload.query && payload.query.hasOwnProperty('after')) {
          commit('ADD_MODELS', response.data);
        } else {
          commit('SET_MODELS', response.data);
        }

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  read({ commit, rootState }, payload: { id: number; workspaceId: number }) {
    return rootState.api
      .get(`${resource}/${payload.id}`, { withCredentials: true, headers: { common: { 'x-workspace-id': payload.workspaceId } } })
      .then((response: { data: Order }) => {
        commit('UPDATE_MODEL', response.data);

        commit('SET_VIEWING', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  reHandle({ commit, rootState }, { id, workspaceId }: { id: number; workspaceId: number }) {
    return rootState.api.post(`${resource}/${id}/re-handle`, undefined, { withCredentials: true, headers: { common: { 'x-workspace-id': workspaceId } } }).catch((e: ErrorResponse) => {
      return Promise.reject(e);
    });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
